import React, {Suspense, lazy} from 'react';
import {ROUTE_DR_RCPA_PLANNING_DETAIL_REPORT} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import {Spin} from 'antd';

const DrRCPAPlanningDetailReport = lazy(() =>
  import('../../../screens/DrRCPAPlanningDetailReport')
    .then(module => ({default: module.DrRCPAPlanningDetailReport})));

const DrRCPAPlanningDetailReportNavigation = [
  {
    path: ROUTE_DR_RCPA_PLANNING_DETAIL_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <DrRCPAPlanningDetailReport />
      </Suspense>
    ),
  },
];

export default DrRCPAPlanningDetailReportNavigation;
